<template>
  <ul class="menu-nav">
    <router-link
      to="/dashboard"
      class="d-none"
      v-slot="{ href, navigate, isActive, isExactActive }">
      <li
        v-wave
        aria-haspopup="true"
        data-menu-toggle="hover"
        class="menu-item"
        :class="[
          isActive && 'menu-item-active',
          isExactActive && 'menu-item-active',
        ]">
        <a
          :href="href"
          class="menu-link"
          @click="navigate">
          <i class="menu-icon fa fa-th-large fa-lg"></i>
          <span class="menu-text">Dashboard</span>
        </a>
      </li>
    </router-link>

    <li class="menu-section d-none">
      <h4 class="menu-text">Menu</h4>
      <i class="menu-icon fa fa-ellipsis-h"></i>
    </li>

    <li
      aria-haspopup="true"
      v-wave
      data-menu-toggle="hover"
      class="menu-item menu-item-submenu d-none"
      v-bind:class="{ 'menu-item-open': hasActiveChildren('/statistics') }">
      <a
        href="#"
        class="menu-link menu-toggle">
        <i class="menu-icon fa fa-chart-line fa-lg"></i>
        <span class="menu-text">Statistics</span>
        <i class="menu-arrow fa fa-chevron-right fa-sm"></i>
      </a>
      <div class="menu-submenu">
        <span class="menu-arrow"></span>
        <ul class="menu-subnav">
          <li
            aria-haspopup="true"
            class="menu-item menu-item-parent">
            <span class="menu-link">
              <span class="menu-text">Statistics</span>
            </span>
          </li>

          <router-link
            to="/statistics/grafana"
            v-slot="{ href, navigate, isActive, isExactActive }">
            <li
              aria-haspopup="true"
              data-menu-toggle="hover"
              class="menu-item"
              :class="[
                isActive && 'menu-item-active',
                isExactActive && 'menu-item-active'
              ]">
              <a
                :href="href"
                class="menu-link"
                @click="navigate">
                <i class="menu-bullet menu-bullet-dot">
                  <span></span>
                </i>
                <span class="menu-text">Grafana</span>
              </a>
            </li>
          </router-link>

          <router-link
            to="/statistics/webhooks"
            v-slot="{ href, navigate, isActive, isExactActive }">
            <li
              aria-haspopup="true"
              data-menu-toggle="hover"
              class="menu-item"
              :class="[
                isActive && 'menu-item-active',
                isExactActive && 'menu-item-active'
              ]">
              <a
                :href="href"
                class="menu-link"
                @click="navigate">
                <i class="menu-bullet menu-bullet-dot">
                  <span></span>
                </i>
                <span class="menu-text">Webhooks</span>
              </a>
            </li>
          </router-link>

        </ul>
      </div>
    </li>

    <router-link
      :to="{ path: '/servers', query: { limit: 10, page: 1, sort: 'created', ord: 'desc' } }"
      v-slot="{ href, navigate, isActive, isExactActive }">
      <li
        aria-haspopup="true"
        v-wave
        data-menu-toggle="hover"
        class="menu-item"
        v-bind:class="{ 'menu-item-active': hasActiveChildren('/servers') }">
        <a
          :href="href"
          class="menu-link"
          @click="navigate">
          <i class="menu-icon fa fa-server fa-lg"></i>
          <span class="menu-text">Servers</span>
        </a>
      </li>
    </router-link>

    <router-link
      :to="{ path: '/resellers', query: { limit: 10, page: 1, sort: 'created', ord: 'desc' } }"
      v-slot="{ href, navigate, isActive, isExactActive }">
      <li
        aria-haspopup="true"
        v-wave
        data-menu-toggle="hover"
        class="menu-item"
        v-bind:class="{ 'menu-item-active': hasActiveChildren('/resellers') }">
        <a
          :href="href"
          class="menu-link"
          @click="navigate">
          <i class="menu-icon fa fa-people-arrows fa-lg"></i>
          <span class="menu-text">Resellers</span>
        </a>
      </li>
    </router-link>

    <router-link
      :to="{ path: '/users', query: { limit: 10, page: 1, sort: 'created', ord: 'desc' } }"
      v-slot="{ href, navigate, isActive, isExactActive }">
      <li
        aria-haspopup="true"
        v-wave
        data-menu-toggle="hover"
        class="menu-item"
        v-bind:class="{ 'menu-item-active': hasActiveChildren('/users') }">
        <a
          :href="href"
          class="menu-link"
          @click="navigate">
          <i class="menu-icon fa fa-users fa-lg"></i>
          <span class="menu-text">Users</span>
        </a>
      </li>
    </router-link>

    <li
      aria-haspopup="true"
      data-menu-toggle="hover"
      class="menu-item menu-item-submenu d-none"
      v-bind:class="{ 'menu-item-open': hasActiveChildren('/tools') }">
      <a
        href="#"
        class="menu-link menu-toggle">
        <i class="menu-icon fa fa-tools fa-lg"></i>
        <span class="menu-text">Tools</span>
        <i class="menu-arrow fa fa-chevron-right fa-sm"></i>
      </a>
      <div class="menu-submenu">
        <span class="menu-arrow"></span>
        <ul class="menu-subnav">
          <li
            aria-haspopup="true"
            v-wave
            class="menu-item menu-item-parent">
            <span class="menu-link">
              <span class="menu-text">Tools</span>
            </span>
          </li>

          <router-link
            to="/tools/news"
            v-slot="{ href, navigate, isActive, isExactActive }">
            <li
              aria-haspopup="true"
              v-wave
              data-menu-toggle="hover"
              class="menu-item"
              :class="[
                isActive && 'menu-item-active',
                isExactActive && 'menu-item-active'
              ]">
              <a
                :href="href"
                class="menu-link"
                @click="navigate">
                <i class="menu-bullet menu-bullet-dot">
                  <span></span>
                </i>
                <span class="menu-text">News</span>
              </a>
            </li>
          </router-link>

          <router-link
            to="/tools/log-search"
            v-slot="{ href, navigate, isActive, isExactActive }">
            <li
              aria-haspopup="true"
              v-wave
              data-menu-toggle="hover"
              class="menu-item"
              :class="[
                isActive && 'menu-item-active',
                isExactActive && 'menu-item-active'
              ]">
              <a
                :href="href"
                class="menu-link"
                @click="navigate">
                <i class="menu-bullet menu-bullet-dot">
                  <span></span>
                </i>
                <span class="menu-text">Log Search</span>
              </a>
            </li>
          </router-link>

          <router-link
            to="/tools/console"
            v-slot="{ href, navigate, isActive, isExactActive }">
            <li
              aria-haspopup="true"
              v-wave
              data-menu-toggle="hover"
              class="menu-item"
              :class="[
                isActive && 'menu-item-active',
                isExactActive && 'menu-item-active'
              ]">
              <a
                :href="href"
                class="menu-link"
                @click="navigate">
                <i class="menu-bullet menu-bullet-dot">
                  <span></span>
                </i>
                <span class="menu-text">Console</span>
              </a>
            </li>
          </router-link>

        </ul>
      </div>
    </li>
    
    <li class="menu-section">
      <h4 class="menu-text">Account</h4>
      <i class="menu-icon fa fa-ellipsis-h"></i>
    </li>

    <router-link
      to="/profile"
      v-slot="{ href, navigate, isActive, isExactActive }"
      class="d-none">
      <li
        aria-haspopup="true"
        v-wave
        data-menu-toggle="hover"
        class="menu-item"
        :class="[
          isActive && 'menu-item-active',
          isExactActive && 'menu-item-active',
        ]">
        <a
          :href="href"
          class="menu-link"
          @click="navigate">
          <i class="menu-icon fa fa-user fa-lg"></i>
          <span class="menu-text">Profile</span>
        </a>
      </li>
    </router-link>

    <li
      aria-haspopup="true"
      data-menu-toggle="hover"
      class="menu-item menu-item-submenu"
      v-bind:class="{ 'menu-item-open': hasActiveChildren('/settings') }">
      <a
        href="#"
        class="menu-link menu-toggle">
        <i class="menu-icon fa fa-wrench fa-lg"></i>
        <span class="menu-text">Settings</span>
        <i class="menu-arrow fa fa-chevron-right fa-sm"></i>
      </a>
      <div class="menu-submenu">
        <span class="menu-arrow"></span>
        <ul class="menu-subnav">
          <li
            aria-haspopup="true"
            v-wave
            class="menu-item menu-item-parent">
            <span class="menu-link">
              <span class="menu-text">Settings</span>
            </span>
          </li>

          <router-link
            to="/settings/general"
            v-slot="{ href, navigate, isActive, isExactActive }"
            class="d-none">
            <li
              aria-haspopup="true"
              v-wave
              data-menu-toggle="hover"
              class="menu-item"
              :class="[
                isActive && 'menu-item-active',
                isExactActive && 'menu-item-active'
              ]">
              <a
                :href="href"
                class="menu-link"
                @click="navigate">
                <i class="menu-bullet menu-bullet-dot">
                  <span></span>
                </i>
                <span class="menu-text">General</span>
              </a>
            </li>
          </router-link>

          <router-link
            to="/settings/tariffs"
            v-slot="{ href, navigate, isActive, isExactActive }">
            <li
              aria-haspopup="true"
              v-wave
              data-menu-toggle="hover"
              class="menu-item"
              :class="[
                isActive && 'menu-item-active',
                isExactActive && 'menu-item-active'
              ]">
              <a
                :href="href"
                class="menu-link"
                @click="navigate">
                <i class="menu-bullet menu-bullet-dot">
                  <span></span>
                </i>
                <span class="menu-text">Tariffs</span>
              </a>
            </li>
          </router-link>

          <router-link
            to="/settings/groups"
            v-slot="{ href, navigate, isActive, isExactActive }">
            <li
              aria-haspopup="true"
              v-wave
              data-menu-toggle="hover"
              class="menu-item"
              :class="[
                isActive && 'menu-item-active',
                isExactActive && 'menu-item-active'
              ]">
              <a
                :href="href"
                class="menu-link"
                @click="navigate">
                <i class="menu-bullet menu-bullet-dot">
                  <span></span>
                </i>
                <span class="menu-text">Groups</span>
              </a>
            </li>
          </router-link>

          <router-link
            to="/settings/firewalls"
            v-slot="{ href, navigate, isActive, isExactActive }">
            <li
              aria-haspopup="true"
              v-wave
              data-menu-toggle="hover"
              class="menu-item"
              :class="[
                isActive && 'menu-item-active',
                isExactActive && 'menu-item-active'
              ]">
              <a
                :href="href"
                class="menu-link"
                @click="navigate">
                <i class="menu-bullet menu-bullet-dot">
                  <span></span>
                </i>
                <span class="menu-text">Firewalls</span>
              </a>
            </li>
          </router-link>


          <router-link
            to="/settings/vpn-servers"
            v-slot="{ href, navigate, isActive, isExactActive }">
            <li
              aria-haspopup="true"
              v-wave
              data-menu-toggle="hover"
              class="menu-item"
              :class="[
                isActive && 'menu-item-active',
                isExactActive && 'menu-item-active'
              ]">
              <a
                :href="href"
                class="menu-link"
                @click="navigate">
                <i class="menu-bullet menu-bullet-dot">
                  <span></span>
                </i>
                <span class="menu-text">VPN Servers</span>
              </a>
            </li>
          </router-link>

          <router-link
            to="/settings/recipes"
            v-slot="{ href, navigate, isActive, isExactActive }">
            <li
              aria-haspopup="true"
              v-wave
              data-menu-toggle="hover"
              class="menu-item"
              :class="[
                isActive && 'menu-item-active',
                isExactActive && 'menu-item-active'
              ]">
              <a
                :href="href"
                class="menu-link"
                @click="navigate">
                <i class="menu-bullet menu-bullet-dot">
                  <span></span>
                </i>
                <span class="menu-text">Recipes</span>
              </a>
            </li>
          </router-link>

          <router-link
            to="/settings/recipes-groups"
            v-slot="{ href, navigate, isActive, isExactActive }">
            <li
              aria-haspopup="true"
              v-wave
              data-menu-toggle="hover"
              class="menu-item"
              :class="[
                isActive && 'menu-item-active',
                isExactActive && 'menu-item-active'
              ]">
              <a
                :href="href"
                class="menu-link"
                @click="navigate">
                <i class="menu-bullet menu-bullet-dot">
                  <span></span>
                </i>
                <span class="menu-text">Recipes Groups</span>
              </a>
            </li>
          </router-link>

          <router-link
            to="/settings/macroses"
            v-slot="{ href, navigate, isActive, isExactActive }">
            <li
              aria-haspopup="true"
              v-wave
              data-menu-toggle="hover"
              class="menu-item"
              :class="[
                isActive && 'menu-item-active',
                isExactActive && 'menu-item-active'
              ]">
              <a
                :href="href"
                class="menu-link"
                @click="navigate">
                <i class="menu-bullet menu-bullet-dot">
                  <span></span>
                </i>
                <span class="menu-text">Macros Variables</span>
              </a>
            </li>
          </router-link>

          <router-link
            to="/settings/countries"
            v-slot="{ href, navigate, isActive, isExactActive }">
            <li
              aria-haspopup="true"
              v-wave
              data-menu-toggle="hover"
              class="menu-item"
              :class="[
                isActive && 'menu-item-active',
                isExactActive && 'menu-item-active'
              ]">
              <a
                :href="href"
                class="menu-link"
                @click="navigate">
                <i class="menu-bullet menu-bullet-dot">
                  <span></span>
                </i>
                <span class="menu-text">Countries</span>
              </a>
            </li>
          </router-link>

        </ul>
      </div>
    </li>
  </ul>
</template>

<script>
export default {
  name: 'KTMenu',
  methods: {
    hasActiveChildren(match) {
      return this.$route['path'].indexOf(match) !== -1
    },
  },
}
</script>
